import { render, staticRenderFns } from "./navigation-settings.vue?vue&type=template&id=9ce847f2&"
import script from "./navigation-settings.vue?vue&type=script&lang=js&"
export * from "./navigation-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports